import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/internal/operators';
import { Observable, of } from 'rxjs/index';
import { HttpClient } from '@angular/common/http';
import { InterventionsFilters } from '../../actions/interventions/model/interventions-filters';
import { ApiRoutes } from 'src/app/config/api-routes';
import { PaginationResponse } from '../model/paginationResponse';
import { ActionStatusType } from '../enums/enums';
import { ActionSummary } from '../model/action';
import { InterventionsBusinessRules } from '../model/interventions-business-rules';

@Injectable()
export class InterventionsService {

  constructor(
    private httpClient: HttpClient,
    private config: ApiRoutes,
  ) {
  }

  public getActions(statuses: ActionStatusType[], filters: InterventionsFilters): Observable<ActionSummary[]> {
    const clonedFilters = filters.clone();
    clonedFilters.statuses = filters.statuses?.length ? filters.statuses : statuses;
    clonedFilters.pageSize = 1000;
    clonedFilters.pageNumber = 1;
    const url = this.config.ACTIONS + clonedFilters.convertToQueryString();

    return this.httpClient.get<PaginationResponse<ActionSummary>>(url).pipe(
      map(response => response.items)
    );
  }

  public assignAction(teamId: any, actionId: string, priority: number): Observable<any> {
    return this.httpClient.post(
      this.config.ACTION_ASSIGN,
      {
        interventionTeamId: teamId,
        actionId: actionId,
        priority: priority
      }
    );
  }

  public assignActions(teamId: string, actionIds: string[], sendToInterventionTeam: boolean): Observable<string[]> {
    return this.httpClient.post<string[]>(
      this.config.ACTIONS_ASSIGN,
      {
        interventionTeamId: teamId,
        actionIds: actionIds,
        sendToInterventionTeam: sendToInterventionTeam
      }
    );
  }

  public prioritizeAction(actionId: string, priority: number): Observable<any> {
    return this.httpClient.post(
      this.config.ACTION_PRIORITIZE,
      {
        actionId: actionId,
        priority: priority
      }
    );
  }

  public getInterventionsRules(): Observable<InterventionsBusinessRules> {
    return this.httpClient.get<InterventionsBusinessRules>(this.config.INTERVENTIONS_BUSINESS_RULES).pipe(
      catchError(error => {
        return of(new InterventionsBusinessRules());
      })
    );
  }

  public sendActionsToInterventionTeam(interventionTeamId: string): Observable<any> {
    const route = ApiRoutes.getRouteWithInjectedParams(this.config.ACTION_SEND_ALL, [interventionTeamId]);
    return this.httpClient.get<any>(route);
  }

  public deleteAction(action: ActionSummary) {
    const route = ApiRoutes.getRouteWithInjectedParams(this.config.ACTION_DELETE, [action.id]);
    return this.httpClient.delete(route);
  }

  public deleteActions(actions: ActionSummary[]) {
    const route = this.config.ACTIONS_DELETE;
    const guidsToDelete = actions.map(action => action.id);
    return this.httpClient.post(route, guidsToDelete);
  }
}
